/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { disposeSymbol } from "../util/index.js";
export class NoOpChangeEnricher {
    applyTipChange(change, revision) { }
    updateChangeEnrichments(change, revision) {
        return change;
    }
    fork() {
        return new NoOpChangeEnricher();
    }
    [disposeSymbol]() { }
}
//# sourceMappingURL=changeEnricher.js.map